function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roles-grid"},_vm._l((_vm.productRoles),function(ref){
var id = ref.id;
var rest$1 = objectWithoutProperties( ref, ["id"] );
var rest = rest$1;
return _c('Card',{key:id,attrs:{"dis-hover":""}},[_c('Role',_vm._b({attrs:{"edit":""}},'Role',Object.assign({}, {id: id}, rest),false))],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }